export default "__VITE_ASSET__fcb3095e__"